import * as rq from '@tanstack/react-query';

import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

import { useDependencies } from '../contexts/dependencies.context';

export namespace ListEntities {
  export const key = (input: Input, repository: IWarrantyRepository) => [
    'warranty',
    'get-list-entities',
    repository.key,
    input.level,
    input.assetFullFrontendId,
    input.filters,
  ];

  export type Input = IWarrantyRepository.ListEntitiesInput;
  export type Output = IWarrantyRepository.ListEntitiesOutput;
  export type Params = { refetchInterval?: number };

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input, repositories.warranty),
      queryFn: () => repositories.warranty.listEntities(input),
    });
  }
}
